import { api } from "./backend";

export function crear() {
  return {
    id: 0,
    carpetaId: null,
    nombre: "",
    enlace: "",
    creadoEl: "",
    usuarioId: "",
    tipo: null,
    estado: true,
  };
}

export function listar() {
  return api.get("repositoriosComerciales/listar").then((response) => {
    var datos = response.data[0];
    actualizarEstado(datos);
    return response.data[0];
  });
}

export function insertar(repositorioComercial) {
  return api.post("repositoriosComerciales/insertar", {
    repositorioComercial: repositorioComercial,
  });
}

export function actualizar(repositorioComercial) {
  return api.post("repositoriosComerciales/actualizar", {
    repositoriocomercial: repositorioComercial,
  });
}

export function eliminar(id) {
  return api.post("repositoriosComerciales/eliminar", { id });
}

export function actualizarEstado(repositorioComercial) {
  repositorioComercial.datos.estado = Boolean(repositorioComercial.datos.estado);
  if (repositorioComercial.hijos !== undefined && repositorioComercial.hijos.length) {
    repositorioComercial.hijos.forEach((element) => {
      actualizarEstado(element);
    });
  }
}
